import * as React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { ClipLoader } from 'react-spinners';
import { NotificationSection } from './NotificationSection';
import { INotificationResponse, NotificationType, IAuthState } from 'src/modules/Auth/store/types';
import NotificationSidebarLinks from './components/NotificationsSidebarLinks';
import { timestampToDateTimeString } from 'src/share/utils/utils';
import { bindActionCreators } from 'redux';
import { IReduxState } from 'src/reduxTypes';
import { loginActions } from 'src/modules/Auth/store/actions';
import './notifications.css';
import Sidebar from 'src/modules/Routing/Sidebar/Siderbar';

export interface INotificationFeedProps {
  auth: IAuthState;
  getNotifications: () => INotificationResponse;
  deleteNotifications: (ids, key) => void;
  lastLogin: number | null;
}

export interface INotificationFeedState {
  notifications: INotificationResponse;
  notificationItems: { [type: string]: boolean };
  loading: boolean;
}

class NotificationFeed extends React.PureComponent<INotificationFeedProps, INotificationFeedState>{
  constructor(props: INotificationFeedProps) {
    super(props);
    this.state = {
      notifications: {},
      notificationItems: {},
      loading: false
    };
  }

  public componentDidMount() {
    this.loadNotifications();
  }

  public componentDidUpdate(prevProps: INotificationFeedProps) {
    const { notifications } = this.props.auth;
    const { notifications: prevNotifications } = prevProps.auth;
    if (notifications !== prevNotifications) {
      this.setState({ notifications });
    }
  }

  public async loadNotifications() {
    try {
      this.setState({ loading: true });
      await this.props.getNotifications();
      this.setState({ loading: false })
    } catch {
      toastr.error('Error', 'There was a problem loading the notifications');
    }
  }

  public deleteNotificationSections = async (typeKey: string) => {
    this.setState({ loading: true });
    const types = this.state.notifications[typeKey];
    const handlers = Object.keys(types).map(notificationKey => types[notificationKey].id);
    if (handlers) {
      try {
        await this.props.deleteNotifications(handlers, typeKey);
      } catch (error) {
        toastr.error('Error', 'There was a problem deleting the notification');
      }
    }
    this.setState({ loading: false });
  }

  public toggleSection = (type: string) => {
    const sections = {};
    sections[type] = !this.state.notificationItems[type];
    this.setState({ notificationItems: sections });
  }

  public render() {
    const { notifications, notificationItems, loading } = this.state;
    const types = Object.keys(NotificationType).map(key => NotificationType[key]);
    return (
      <Sidebar className="notification-feed">
        <div className="notification-header">
          <div>
            <h2>Notifications</h2>
          </div>
          <div className="notification-loader">
            <ClipLoader color={'#a8babc'} size={22} loading={loading} />
          </div>
        </div>
        {
          types.map(typeKey =>
            <NotificationSection
              notifications={notifications && notifications[typeKey] || {}}
              onDeleteNotification={() => this.deleteNotificationSections(typeKey)}
              type={typeKey}
              toggle={() => this.toggleSection(typeKey)}
              collapse={notificationItems[typeKey]}
              key={typeKey}
            />
          )
        }
        <div className="notification-links">
          <NotificationSidebarLinks />
        </div>
        <h6 className={"lastVisit"}>{this.props.lastLogin ? `Last visit:   ${timestampToDateTimeString(this.props.lastLogin)}` : "Welcome to GMCNgine™"}</h6>
      </Sidebar>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});
const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({
    getNotifications: loginActions.getNotifications,
    deleteNotifications: loginActions.deleteNotifications
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationFeed);



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Notifications/NotificationFeed.tsx